<template>
  <div class="groupSelect">
    <el-input
      placeholder="搜索分组名称"
      v-model="filterTree"
    ></el-input>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      @current-change="curNodeChange"
      default-expand-all
      :filter-node-method="filterNode"
      ref="tree"
      :render-content="renderTreeContent"
      highlight-current
      :expand-on-click-node="false"
      node-key="Type"
      v-model:current-node-key.sync="currentNode.Type"
    ></el-tree>
    <i
      v-if="isAdd"
      class="el-icon-plus add"
      @click="showGroup(2)"
    >添加分组</i>

    <!--新增修改分组名称 strat-->
    <el-dialog
      title="名称"
      v-model="dialogOpt.show"
      width="30%"
      :before-close="() => (dialogOpt.show = 0)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-input
        v-model="dialogOpt.value"
        placeholder="请输入内容"
      ></el-input>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="dialogOpt.show = 0">取 消</el-button>
          <el-button
            type="primary"
            @click="onOptSave"
          >确 定</el-button>
        </span></template>
    </el-dialog>
    <!--新增修改分组名称 end-->
  </div>
</template>
<script>
import {
  AddResourceGroup,
  ModifyResourceGroup,
  DeleteResourceGroup,
} from "@api/ApiResourceGroup";
import {getUserInfo} from '@/util/authority'
export default {
  name: "groupSelect",
  data() {
    return {
      filterTree: "",
      defaultProps: {
        children: "MenuList",
        label: "Name",
      },
      dialogOpt: {
        show: false,
        current: {},
        value: "",
      },
    };
  },
  props: [
    "groupTypeCode",
    "treeData",
    "currentNode",
    "isDelete",
    "isRename",
    "isAdd",
  ],
  components: {},
  methods: {
    onOptSave() {
      if (!this.dialogOpt.value) {
        this.$message.warning("名称不能为空!");
        return;
      }
      if (this.dialogOpt.show == 1) {
        this.renameSave();
      } else {
        this.addSave();
      }
    },
    //新增分组
    addSave() {
      let that = this;
      let params = {
        name: that.dialogOpt.value,
        creatorName: getUserInfo().CodeID,
        type: that.groupTypeCode,
      };
      AddResourceGroup(params).then(function (data) {
          that.$message.success("新增成功!");
          that.$emit("Refresh");
          that.dialogOpt.show = 0;
          that.dialogOpt.current = null;
          that.dialogOpt.value = "";
      });
    },
    //自定义树状
    renderTreeContent(h, { node, data, store }) {
      // debugger
      let noType = ["RootNode", "NotGrouped"];
      var deleteDom = (
        <i
          title="删除"
          onClick={() => this.deleteGroup(data)}
          class="el-icon-delete"
        ></i>
      );
      var renameDom = (
        <i
          title="重命名"
          onClick={() => this.showGroup(1, data)}
          class="el-icon-edit"
        ></i>
      );
      var show =
        this.currentNode &&
        this.currentNode.Type == data.Type &&
        noType.indexOf(data.Type) < 0 && data.Type!=-1;
      return (
        <span>
          <span>
            {data.Name}
          </span>
          <span class="curr-node-opt">
            {show && this.isDelete ? deleteDom : ""}
            {show && this.isRename ? renameDom : ""}
          </span>
        </span>
      );
    },
    //删除分组
    deleteGroup(data) {
      debugger
      let that = this;
      this.$confirm("确定删除当前分组？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        DeleteResourceGroup(data.Type).then(function (result) {
          that.$message.success("删除成功!");
          that.$emit("Refresh");
        });
      });
    },
    //重命名分组
    renameSave() {
      let that = this;
      let data = {
        id: that.dialogOpt.current.Type,
        name: that.dialogOpt.value,
        lastModifierName: getUserInfo().CodeID,
        type: that.groupTypeCode,
      };
      ModifyResourceGroup(data).then(function(result)
      {
        that.$message.success("修改成功!");
        that.$emit("Refresh");
        that.dialogOpt.show = 0;
        that.dialogOpt.current = null;
        that.dialogOpt.value = "";
      });
    },
    showGroup(type, data) {
      this.dialogOpt.value = "";
      this.dialogOpt.show = type;
      if (data) {
        this.dialogOpt.current = data;
        this.dialogOpt.value = data.Name;
      }
    },
    curNodeChange(data, node) {
      this.$emit("update:currentNode", data);
    },
    //树形搜索条件
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
  },
  computed: {},
  watch: {
    filterTree(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
.groupSelect {
  position: relative;
  height: 100%;
}
.groupSelect .add {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  height: 34px;
  line-height: 34px;
  border-top: 1px solid #c9cace;
  cursor: pointer;
}

.groupSelect >>> .curr-node-opt {
  position: absolute;
  right: 5px;
}
.groupSelect >>> .curr-node-opt i {
  margin-left: 5px;
}
</style>